import { Flex, Text } from '@mantine/core';
import React from 'react';
import IconGreenFeatureGIGR from '../../icons/IconGreenFeatureGIGR';
import IconGreenFeatureSubmerchant from '../../icons/IconGreenFeatureSubmerchant';
import IconGreenFeatureVerifRegist from '../../icons/IconGreenFeatureVerifRegist';
// import IconGreenFeatureVerifTrx from '../../icons/IconGreenFeatureVerifTrx';
import IconRedFeatureGIGR from '../../icons/IconRedFeatureGIGR';
import IconRedFeatureSubmerchant from '../../icons/IconRedFeatureSubmerchant';
import IconRedFeatureVerifRegist from '../../icons/IconRedFeatureVerifRegist';
// import IconRedFeatureVerifTrx from '../../icons/IconRedFeatureVerifTrx';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const ListFeature = ({
  isActive = false,
  feature = 'gigr',
  createdBy = '',
  name = '',
  updatedAt = '',
  withTimeLine = true
}) => {
  const contents = {
    gigr: {
      iconActive: <IconGreenFeatureGIGR/>,
      iconInActive: <IconRedFeatureGIGR/>,
      featureName: name
    },
    ['subpangkalan-registration']: {
      iconActive: <IconGreenFeatureSubmerchant/>,
      iconInActive: <IconRedFeatureSubmerchant/>,
      featureName: name
    },
    ['customer-verification']: {
      iconActive: <IconGreenFeatureVerifRegist/>,
      iconInActive: <IconRedFeatureVerifRegist/>,
      featureName: name
    },
    // verifTrx: {
    //   iconActive: <IconGreenFeatureVerifTrx/>,
    //   iconInActive: <IconRedFeatureVerifTrx/>,
    //   featureName: 'Verifikasi Pelanggan di Penjualan'
    // },
  };
  return (
    <Flex align="center" gap="sm">
      {isActive ? contents[feature]?.iconActive : contents[feature]?.iconInActive}
      <div>
        <Text fw={600} fz="sm">{contents[feature]?.featureName}</Text>
        {withTimeLine && <Text c="#52575C" fz="sm">{`${
          isActive ? 'Aktif' : 'Tidak aktif'
        } | ${updatedAt ? dayjs(updatedAt).locale('id').format('DD MMM YYYY') : '-'} | ${createdBy || '-'}`}</Text>}
      </div>
    </Flex>
  );
};

export default ListFeature;

ListFeature.propTypes = {
  createdBy: PropTypes.string,
  feature: PropTypes.string,
  isActive: PropTypes.bool,
  name: PropTypes.string,
  timeline: PropTypes.string,
  updatedAt: PropTypes.string,
  withTimeLine: PropTypes.bool
};
